export const AVATAR_COLORS = [
  "#10B981", "#3B82F6", "#F59E0B", "#EF4444", "#8B5CF6", "#EC4899",
  "#06B6D4", "#84CC16", "#F97316", "#14B8A6", "#6366F1", "#E11D48",
];

export function initials(name = "") {
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function colorFor(id = "") {
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) >>> 0;
  return AVATAR_COLORS[h % AVATAR_COLORS.length];
}

export function setsSummary(sets = []) {
  if (!sets.length) return "";
  return sets.map((s) => `${s.g1}-${s.g2}`).join("  ");
}

export function nextMatchday(matchdays = []) {
  const pending = matchdays.find((m) => m.matches.some((x) => x.status !== "completed"));
  return pending || matchdays[matchdays.length - 1] || null;
}

export const RULES = [
  { label: "Vittoria 2-0", pts: 3, tone: "emerald" },
  { label: "Vittoria 2-1", pts: 2, tone: "blue" },
  { label: "Sconfitta 1-2", pts: 1, tone: "amber" },
  { label: "Sconfitta 0-2", pts: 0, tone: "rose" },
];

export function winRate(stats) {
  return stats && stats.played ? Math.round((stats.wins / stats.played) * 100) : 0;
}

export function computeRadar(stats) {
  if (!stats) return [];
  const played = stats.played || 0;
  const per = (v) => (played ? v / played : 0);
  const clamp = (v) => Math.max(5, Math.min(100, Math.round(v)));
  const wr = winRate(stats);
  return [
    { axis: "Attacco", v: clamp((per(stats.games_won) / 14) * 100) },
    { axis: "Difesa", v: clamp(100 - (per(stats.games_lost) / 14) * 100) },
    { axis: "Costanza", v: clamp(wr) },
    { axis: "Clutch", v: clamp(stats.three_set ? (stats.three_set_wins / stats.three_set) * 100 : wr) },
    { axis: "Efficienza", v: clamp(played ? (stats.points / (played * 3)) * 100 : 0) },
  ];
}
